import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const accessToken = this.authService.getAccessToken();

    // Check if the request is a login request
    if (req.url.includes('/signin') || req.url.includes('/config/')) {
      return next.handle(req);
    }

    if (accessToken) {
      const cloned = req.clone({
        setHeaders: {
          'auth': `${accessToken}`,
          'source': 'web'
        },
      });

      return next.handle(cloned).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            // Handle 401 Unauthorized error
            this.handleUnauthorizedError();
          }
          return throwError(error);
        })
      );
    }

    return next.handle(req);
  }

  private handleUnauthorizedError() {
    // Clear tokens and navigate to login page
    this.authService.clearTokensAndUserData();
    this.router.navigate(['/signin']);
  }
}
